import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const estimateNoteApi = createApi({
    reducerPath: "estimateNoteApi",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ["EstimateNote"],
    endpoints: (builder) => ({

        // GET ALL NOTES
        getEstimateNotes: builder.query({
            query: () => ({
                url: `/admin/estimate-notes`,
                method: "GET",
            }),
            providesTags: ["EstimateNote"],
        }),

        // GET NOTE BY ID
        getEstimateNoteById: builder.query({
            query: (id) => ({
                url: `/admin/estimate-note/${id}`,
                method: "GET",
            }),
            providesTags: ["EstimateNote"],
        }),

        // ADD NOTE
        addEstimateNote: builder.mutation({
            query: (data) => ({
                url: `/admin/estimate-note`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["EstimateNote"],
        }),

        // UPDATE NOTE
        updateEstimateNote: builder.mutation({
            query: ({ id, data }) => ({
                url: `/admin/estimate-note/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["EstimateNote"],
        }),

        // DELETE NOTE
        deleteEstimateNote: builder.mutation({
            query: (id) => ({
                url: `/admin/estimate-note/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["EstimateNote"],
        }),

        // GET DEFAULT NOTE
        getDefaultEstimateNote: builder.query({
            query: () => ({
                url: `/admin/estimate-note-default`,
                method: "GET",
            }),
            providesTags: ["EstimateNote"],
        }),

    }),
});

export const {
    useGetEstimateNotesQuery,
    useGetEstimateNoteByIdQuery,
    useAddEstimateNoteMutation,
    useUpdateEstimateNoteMutation,
    useDeleteEstimateNoteMutation,
    useGetDefaultEstimateNoteQuery,
} = estimateNoteApi;